import BaseContainer from "@components/ui/BaseContainer";
import clsx from "clsx";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import classes from "./Solutions.module.scss";

const Solutions = () => {
  const { t } = useTranslation();

  const list: { title: string; description: string; link: string }[] = t(
    "solutions.list",
    { returnObjects: true }
  );

  return (
    <BaseContainer className={classes.solutions} id="solutions">
      <AnimationOnScroll animateIn="animate__fadeInLeft" animateOnce>
        <h3 className={classes.solutions__title}>{t("solutions.title")}</h3>
      </AnimationOnScroll>

      <div className={classes.solutions__info}>
        <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce>
          <h2 className={classes.solutions__subtitle}>
            {t("solutions.subtitle")}
          </h2>
        </AnimationOnScroll>
        <ul className={classes.solutions__list}>
          {list.map((item, index) => (
            <li
              className={clsx(classes.solutions__item, classes.item)}
              key={item.title}
            >
              <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce>
                <Link
                  to={item.link}
                  className={clsx(classes.item__link, classes.link)}
                >
                  <div>
                    <h3 className={classes.link__title}>{item.title}</h3>
                  </div>
                  <p className={classes.link__description}>
                    {item.description}
                  </p>
                </Link>
              </AnimationOnScroll>
            </li>
          ))}
        </ul>
      </div>
    </BaseContainer>
  );
};

export default Solutions;
